module.exports = __webpack_public_path__ + "static/media/back3.1bcca326.jpg";